import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicCardFeed {
  constructor(section) {
    const blockCount = section.data.blockCount;

    initCarousel(section.el, {
      perPage: 1,
      gap: '0.5rem',
      pagination: false,
      padding: {
        right: 100,
      },
      breakpoints: {
        [unitlessBreakpoints.xs]: {
          perPage: 2,
          padding: {
            right: 40,
          },
        },
        [unitlessBreakpoints.sm]: {
          perPage: 2,
          padding: {
            right: 80,
          },
        },
        [unitlessBreakpoints.md]: {
          perPage: 3,
          padding: {
            right: 0,
          },
        },
        [unitlessBreakpoints.lg]: {
          perPage: blockCount,
        },
      },
    });
  }
}
